import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type ContactDto = ClientInferResponseBody<typeof contract.contacts.findOne>;

export const fetchContact = async (id: string | undefined): Promise<ContactDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.contacts.findOne.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
